import { trackMonitoringCTA } from '@ecomm/cdp-tracking'
import { Link } from '@ecomm/framework/Link'
import { useCallback } from 'react'
import { useOnLiveGuardCtaClick } from './useOnLiveGuardCtaClick'

type AlarmMomentsCtaProps = {
  readonly text: string
  readonly url: string
}

export function AlarmMomentsCta({ text, url }: AlarmMomentsCtaProps) {
  const trackOnClick = useOnLiveGuardCtaClick()

  const handleClick = useCallback(() => {
    trackOnClick()
    trackMonitoringCTA()
  }, [trackOnClick])

  return (
    <Link
      className="rounded-base border-btn-primary text-btn-primary hover:bg-btn-primary mt-4 w-full cursor-pointer border border-solid px-4 py-3 text-center no-underline transition-colors duration-200 ease-in-out hover:text-white md:mt-6 md:w-fit"
      onClick={handleClick}
      to={url}
      data-component="AlarmMomentsCta"
    >
      {text}
    </Link>
  )
}
